module.exports = __webpack_public_path__ + "img/1954.3ed9bad9.png";